export interface IUserFilterValue {
    email: string;
    allScopes: boolean;
    scopes: string[];
    isAdmin?: boolean;
    display: number;
  }

export class UserFilterValue implements IUserFilterValue {
    email: string;
    allScopes: boolean;
    scopes: string[];
    isAdmin?: boolean;
    display: number;

    constructor() {
      this.email = '';
      this.allScopes = false;
      this.scopes = [];
      this.isAdmin = undefined;
      this.display = 15;
    }
  }

export interface IUser {
    id: number;
    email: string;
    allScopes: boolean;
    scopes: string[];
    isAdmin?: boolean;
  }

export class User implements IUser {
  id: number;
  email: string;
  allScopes: boolean;
  scopes: string[];
  isAdmin?: boolean;

    constructor() {
      this.id = 0;
      this.email = '';
      this.allScopes = false;
      this.scopes = [];
      this.isAdmin = false;
    }
  }



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/modules/userManagement/models.ts